module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Volume-down-6afddc4678de6d7165cef7fb72682c24.svg";